import React from 'react'
import Fade from 'react-reveal/Fade'
import agritechCard from '../assets/images/agritech_card.jpg'

const Detalhes = () => (
  <section className="spotlight style1 bottom inactive" style={{ backgroundImage: `url(${agritechCard})` }}>
    <span className="image fit main">
      <img alt="" src={agritechCard} />
    </span>
    <Fade bottom big>
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-6 col-12-medium">
              <header>
                <h3>Evento</h3>
                <p>
                  1º Hackathon AgriTech - UniLasalle/Lucas
                </p>
                <h3>Inscrições</h3>
                <p>
                  de 27 fevereiro a 12 de março de 2020 (vagas limitadas)
                </p>
              </header>
            </div>
            <div className="col-6 col-12-medium">
              <header>
                <h3>Local</h3>
                <p>
                  Centro Universitário La Salle - Lucas do Rio Verde/MT
                </p>
                <h3>Data</h3>
                <p>
                  13 a 15 de março de 2020 (54 horas ininterruptas de duração)
                </p>
              </header>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  </section>
);

export default Detalhes;
